var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{class:_vm.getClass,attrs:{"elevation":"3","color":_vm.color,"rounded":"","outlined":_vm.outlined,"large":"","disabled":_vm.disabled,"to":_vm.to},on:{"click":_vm.clickAction}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }